import { render } from "./GeometricCorrection.vue?vue&type=template&id=81c63b2a&scoped=true"
import script from "./GeometricCorrection.vue?vue&type=script&lang=js"
export * from "./GeometricCorrection.vue?vue&type=script&lang=js"

import "./GeometricCorrection.vue?vue&type=style&index=0&id=81c63b2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c63b2a"]])

export default __exports__